module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('meta', {
    attrs: {
      "name": "viewport",
      "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
    }
  }), _vm._v(" "), (_vm.$route.params.language === 'en') ? _c('div', [_c('div', {
    staticClass: "col-12 px-0 pt-1 text-center"
  }, [_c('div', {
    staticClass: "col-md-6 row mx-0 p-3"
  }, [_c('button', {
    staticClass: "col-auto btn btn-primary",
    staticStyle: {
      "background-color": "#33135cf2",
      "border-radius": "10px",
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        _vm.isShow = 'A'
      }
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 text-center font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("KH Controller")]), _vm._v(" "), _vm._m(0)]), _vm._v(" \r\n          "), _c('button', {
    staticClass: "col-auto btn btn-primary",
    staticStyle: {
      "background-color": "#33135cf2",
      "border-radius": "10px",
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        _vm.isShow = 'B'
      }
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 text-center font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("CaRx")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 text-center font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Controller")]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), (_vm.isShow == 'A') ? _c('div', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.isShow == 'B') ? _c('div', [_vm._m(3)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$route.params.language === 'vi') ? _c('div', [_c('div', {
    staticClass: "col-12 px-0 pt-1 text-center"
  }, [_c('div', {
    staticClass: "col-md-6 row mx-0 p-3"
  }, [_c('button', {
    staticClass: "col-auto btn btn-primary",
    staticStyle: {
      "background-color": "#33135cf2",
      "border-radius": "10px",
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        _vm.isShow = 'A'
      }
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 text-center font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("KH Controller")]), _vm._v(" "), _vm._m(4)]), _vm._v(" \r\n        "), _c('button', {
    staticClass: "col-auto btn btn-primary",
    staticStyle: {
      "background-color": "#33135cf2",
      "border-radius": "10px",
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        _vm.isShow = 'B'
      }
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 text-center font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("CaRx")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 text-center font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Controller")]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), (_vm.isShow == 'A') ? _c('div', [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.isShow == 'B') ? _c('div', [_vm._m(7)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$route.params.language === 'ms') ? _c('div', [_c('div', {
    staticClass: "col-12 px-0 pt-1 text-center"
  }, [_c('div', {
    staticClass: "col-md-6 row mx-0 p-3"
  }, [_c('button', {
    staticClass: "col-auto btn btn-primary",
    staticStyle: {
      "background-color": "#33135cf2",
      "border-radius": "10px",
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        _vm.isShow = 'A'
      }
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 text-center font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("KH Controller")]), _vm._v(" "), _vm._m(8)]), _vm._v(" \r\n    "), _c('button', {
    staticClass: "col-auto btn btn-primary",
    staticStyle: {
      "background-color": "#33135cf2",
      "border-radius": "10px",
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        _vm.isShow = 'B'
      }
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 text-center font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("CaRx")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 text-center font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("Controller")]), _vm._v(" "), _vm._m(9)])])]), _vm._v(" "), (_vm.isShow == 'A') ? _c('div', [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.isShow == 'B') ? _c('div', [_vm._m(11)]) : _vm._e()]) : (_vm.$route.params.language === 'cn') ? _c('div', {
    attrs: {
      "lang": "zh-Hans"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 pt-1"
  }, [_c('div', {
    staticClass: "col-md-6 row mx-0 p-3 text-center"
  }, [_c('button', {
    staticClass: "col-auto btn btn-primary",
    staticStyle: {
      "background-color": "#33135cf2",
      "border-radius": "10px",
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        _vm.isShow = 'A'
      }
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 text-center font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("KH控制器")]), _vm._v(" "), _vm._m(12)]), _vm._v(" \r\n          "), _c('button', {
    staticClass: "col-auto btn btn-primary",
    staticStyle: {
      "background-color": "#33135cf2",
      "border-radius": "10px",
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        _vm.isShow = 'B'
      }
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 text-center font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("鈣反控制器")]), _vm._v(" "), _vm._m(13)])])]), _vm._v(" "), (_vm.isShow == 'A') ? _c('div', [_vm._m(14)]) : _vm._e(), _vm._v(" "), (_vm.isShow == 'B') ? _c('div', [_vm._m(15)]) : _vm._e()]) : (_vm.$route.params.language === 'tw') ? _c('div', {
    attrs: {
      "lang": "zh-Hant"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 pt-1"
  }, [_c('div', {
    staticClass: "col-md-6 row mx-0 p-3 text-center"
  }, [_c('button', {
    staticClass: "col-auto btn btn-primary",
    staticStyle: {
      "background-color": "#33135cf2",
      "border-radius": "10px",
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        _vm.isShow = 'A'
      }
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 text-center font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("KH控制器")]), _vm._v(" "), _vm._m(16)]), _vm._v(" \r\n          "), _c('button', {
    staticClass: "col-auto btn btn-primary",
    staticStyle: {
      "background-color": "#33135cf2",
      "border-radius": "10px",
      "min-width": "50px"
    },
    on: {
      "click": function($event) {
        _vm.isShow = 'B'
      }
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 text-center font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v("鈣反控制器")]), _vm._v(" "), _vm._m(17)])])]), _vm._v(" "), (_vm.isShow == 'A') ? _c('div', [_vm._m(18)]) : _vm._e(), _vm._v(" "), (_vm.isShow == 'B') ? _c('div', [_vm._m(19)]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 py-1 font-weight-bold"
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": require("../assets/KHA.png")
    }
  }), _vm._v(" KHA")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 py-1 font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": require("../assets/CRA.png")
    }
  }), _vm._v(" CRA")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 pt-0"
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_EN_ppt.pptx?ver=0603",
      "width": "357px",
      "height": "600px",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-auto mt-4 mb-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://v.douyin.com/i8P44fow/"
    }
  }, [_vm._v("Video of quick start installation (Click & Open a new windows)")]), _vm._v(" "), _c('p', [_vm._v("Please check the manual below for detail settings")])]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_EN_doc.docx?ver=0603",
      "width": "100%",
      "height": "40000px",
      "frameborder": "0",
      "overflow-y": "scroll",
      "scrolling": "no"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 pt-0"
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_EN_ppt.pptx?ver=0603",
      "width": "357px",
      "height": "600px",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_EN_doc.docx?ver=0603",
      "width": "100%",
      "height": "40000px",
      "frameborder": "0",
      "overflow-y": "scroll",
      "scrolling": "no"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 py-1 font-weight-bold"
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": require("../assets/KHA.png")
    }
  }), _vm._v(" KHA")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 py-1 font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": require("../assets/CRA.png")
    }
  }), _vm._v(" CRA")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 pt-0"
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_VN_ppt.pptx",
      "width": "357px",
      "height": "600px",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-auto mt-4 mb-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://v.douyin.com/i8P44fow/"
    }
  }, [_vm._v("Video hướng dẫn cài đặt nhanh chóng (Nhấp và Mở cửa sổ mới)")]), _vm._v(" "), _c('p', [_vm._v("Vui lòng kiểm tra hướng dẫn bên dưới để biết cài đặt chi tiết")])]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_VN_doc.docx?page=hsn#toolbar=0",
      "width": "100%",
      "height": "40000px",
      "frameborder": "0",
      "overflow-y": "scroll",
      "scrolling": "no"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 pt-0"
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_CN_ppt.pptx",
      "width": "357px",
      "height": "600px",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_CN_doc.docx?page=hsn#toolbar=0",
      "width": "100%",
      "height": "40000px",
      "frameborder": "0",
      "overflow-y": "scroll",
      "scrolling": "no"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 py-1 font-weight-bold"
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": require("../assets/KHA.png")
    }
  }), _vm._v(" KHA")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 py-1 font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": require("../assets/CRA.png")
    }
  }), _vm._v(" CRA")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 pt-0"
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_MA_ppt.pptx",
      "width": "357px",
      "height": "600px",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-auto mt-4 mb-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://v.douyin.com/i8P44fow/"
    }
  }, [_vm._v("Video of quick start installation (Click & Open a new windows)")]), _vm._v(" "), _c('p', [_vm._v("Please check the manual below for detail settings")])]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_MA_doc.docx?page=hsn#toolbar=0",
      "width": "100%",
      "height": "40000px",
      "frameborder": "0",
      "overflow-y": "scroll",
      "scrolling": "no"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 pt-0"
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_CN_ppt.pptx",
      "width": "357px",
      "height": "600px",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_CN_doc.docx?page=hsn#toolbar=0",
      "width": "100%",
      "height": "40000px",
      "frameborder": "0",
      "overflow-y": "scroll",
      "scrolling": "no"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 py-1 font-weight-bold"
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": require("../assets/KHA.png")
    }
  }), _vm._v(" KHA")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 py-2 font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": require("../assets/CRA.png")
    }
  }), _vm._v(" CRA")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 pt-0"
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_CN_ppt.pptx?ver=0603",
      "width": "357px",
      "height": "600px",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-auto mt-4 mb-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://v.douyin.com/i8P44fow/"
    }
  }, [_vm._v("请先看快速安装影片(点击开新视窗)")]), _vm._v(" "), _c('p', [_vm._v("详细说明及各项设定请参考以下说明书")])]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_CN_doc.docx?ver=0603",
      "width": "100%",
      "height": "45000px",
      "frameborder": "0",
      "overflow-y": "scroll",
      "scrolling": "no"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 pt-0"
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_CN_ppt.pptx?ver=0603",
      "width": "357px",
      "height": "600px",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_CN_doc.docx?ver=0603",
      "width": "100%",
      "height": "40000px",
      "frameborder": "0",
      "overflow-y": "scroll",
      "scrolling": "no"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 py-1 font-weight-bold"
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": require("../assets/KHA.png")
    }
  }), _vm._v(" KHA")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 py-2 font-weight-bold",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": require("../assets/CRA.png")
    }
  }), _vm._v(" CRA")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 pt-0"
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_TW_ppt.pptx?ver=0603",
      "width": "357px",
      "height": "600px",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-auto mt-4 mb-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://v.douyin.com/i8P44fow/"
    }
  }, [_vm._v("請先看快速安裝影片(點擊開新視窗)")]), _vm._v(" "), _c('p', [_vm._v("詳細說明及各項設定請參考以下說明書")])]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/KHA install_TW_doc.docx?ver=0603",
      "width": "100%",
      "height": "50000px",
      "frameborder": "0",
      "overflow-y": "scroll",
      "scrolling": "no"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 px-0 pt-0"
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_TW_ppt.pptx?ver=0603",
      "width": "357px",
      "height": "600px",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "https://view.officeapps.live.com/op/embed.aspx?src=https://aquawiz-web-doc.s3.us-east-2.amazonaws.com/DOC/CRA install_TW_doc.docx?ver=0603",
      "width": "100%",
      "height": "40000px",
      "frameborder": "0",
      "overflow-y": "scroll",
      "scrolling": "no"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06e484cd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 350
// module chunks = 0